import * as React from 'react'
import { Button, Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid2'
import worker_in from '../../asset/worker_in.png'
import worker_out from '../../asset/worker_out.png'
import logo_intro from '../../asset/logo_intro.png'

import { Stack } from 'react-bootstrap'

export default function IntroPage() {
  const navigate = useNavigate()
  const onClickWorkerIn = () => {
    navigate('/Worker/WorkerIN')
  }

  const onClickWorkerOut = () => {
    navigate('/Worker/WorkerOUT')
  }

  return (
    <div style={{ height: 800 }}>
      <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Grid size={12} sx={{ marginTop: 15 }}>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '32px',
              fontWeight: 900,
              lineHeight: '38px',
              textAlign: 'center',
              color: '#FFFFFF',
              textUnderlinePosition: 'from-font',
              textDecorationSkipInk: 'none',
            }}
          >
            원하시는 업무페이지로<br></br>이동해주세요
          </Typography>
        </Grid>
        <Grid size={3} sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 5 }}>
          <Button
            className="intro_button"
            variant="contained"
            sx={{
              borderRadius: '10px',
              background:
                'linear-gradient(0deg, rgba(76, 46, 129, 0.14), rgba(76, 46, 129, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
              width: 270,
              height: 257,
              backdropFilter: 'blur(53px)',
              boxShadow: '-8px 4px 5px 0px #0000003D',
              border: '1px solid',
              borderImageSource:
                'linear-gradient(166.93deg, #AFAFAF 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 67.95%)',
            }}
            onClick={() => onClickWorkerIn()}
          >
            <Stack>
              <img
                style={{ width: '139px', height: '139px', top: '400px', left: '554px', gap: '0px', opacity: '0px' }}
                src={worker_in}
              ></img>
              <Typography>작&nbsp;업&nbsp;투&nbsp;입</Typography>
            </Stack>
          </Button>
          <Typography
            sx={{
              marginTop: 4,
              width: 200,
              height: '38px',
              gap: '0px',
              opacity: '0px',
              fontFamily: 'Roboto',
              fontSize: 20,
              fontWeight: 500,
              lineHeight: '38px',
              textUnderlinePosition: 'from-font',
              textDecorationSkip: 'none',
              color: '#D1D0F4',
            }}
          >
            작업투입 페이지 이동
          </Typography>
        </Grid>
        <Grid size={3} sx={{ justifyItems: 'center', alignItems: 'center', marginTop: 5 }}>
          <Button
            className="intro_button"
            variant="contained"
            sx={{
              borderRadius: '10px',
              background:
                'linear-gradient(0deg, rgba(76, 46, 129, 0.14), rgba(76, 46, 129, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
              width: 270,
              height: 257,
              backdropFilter: 'blur(53px)',
              boxShadow: '-8px 4px 5px 0px #0000003D',
              border: '1px solid',
              borderImageSource:
                'linear-gradient(166.93deg, #AFAFAF 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 67.95%)',
            }}
            onClick={() => onClickWorkerOut()}
          >
            <Stack>
              <img
                style={{ width: '139px', height: '139px', top: '400px', left: '554px', gap: '0px', opacity: '0px' }}
                src={worker_out}
              ></img>
              <Typography>작&nbsp;업&nbsp;철&nbsp;수</Typography>
            </Stack>
          </Button>
          <Typography
            sx={{
              marginTop: 4,
              width: 200,
              height: '38px',
              gap: '0px',
              opacity: '0px',
              fontFamily: 'Roboto',
              fontSize: 20,
              fontWeight: 500,
              lineHeight: '38px',
              textUnderlinePosition: 'from-font',
              textDecorationSkip: 'none',
              color: '#D1D0F4',
            }}
          >
            작업철수 페이지 이동
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box sx={{ textAlign: 'left', marginTop: 15, marginLeft: 5 }}>
            <img style={{ width: 203, height: 57 }} src={logo_intro}></img>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
